// <s-sticky-header> pins the announcement strip and header together and flags when the page
// has scrolled, so the strip can switch to the surface color and blend with the header.
class StickyHeader extends HTMLElement {
  #onScroll = () => this.#sync();

  connectedCallback() {
    this.#sync();
    window.addEventListener("scroll", this.#onScroll, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.#onScroll);
  }

  #sync() {
    this.toggleAttribute("data-scrolled", window.scrollY > 8);
  }
}

if (!customElements.get("s-sticky-header")) {
  customElements.define("s-sticky-header", StickyHeader);
}
